// extracted by mini-css-extract-plugin
export var cardblock = "solution-module--cardblock--0d918";
export var left = "solution-module--left--29124";
export var right = "solution-module--right--bd1f9";
export var solutionType = "solution-module--solutionType--77034";